import React from 'react';
import { useBreakpoint } from '@chakra-ui/react';
import { Text } from '@chakra-ui/react';

export const IsSmallOrLessDisplay = (): boolean => {
  const currentBreakpoint = useBreakpoint({ ssr: false });
  const isSmallDisplay =
    currentBreakpoint === 'sm' || currentBreakpoint === 'base';
  return isSmallDisplay;
};

export const IsSmallDisplay = (): boolean => {
  const currentBreakpoint = useBreakpoint({ ssr: false });
  const isSmallDisplay = currentBreakpoint === 'sm';
  return isSmallDisplay;
};

export const ShowBreakpointAsText = () => {
  return (
    <Text color='black' fontSize='xs'>
      BP: {useBreakpoint()}
    </Text>
  );
};
